/** Brings a checklist line into view without pushing a #hash into the history for every jump. */
export function scrollToLine(e: { preventDefault(): void }, item: string): void {
    e.preventDefault();
    document.getElementById(`line-${item}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
